/** saves the payments list - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_paymentssearch
@payload { array }
*/
export const SAVE_PAYMENTS_LIST = (state, { pageNumber, data }) => {
    state.paymentsList = pageNumber === 1 ? data.payments : state.paymentsList.concat(data.payments)

    state.paymentsHasMore = data.hasMore
}

/** saves operations status list
@payload { array }
*/
export const SAVE_PAYMENTS_STATUS_LIST = (state, payload) => {
    state.paymentsStatusList = payload.paymentStatusViewList.map(payment => {
        return {
            ...payment,
            id: payment.paymentStatusValue.toString(),
            description: payment.paymentStatusDescription
        }
    })
}

export const SAVE_CHANNELS_LIST = (state, payload) => {
    state.channelsList = payload
}

/** saves the operation details
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationsdetails_
*/
export const SAVE_OPERATION_DETAILS = (state, payload) => {
    state.operationDetails = payload.lineGroups
}

/** updates operation favorite status */
export const UPDATE_FAVORITE_STATUS = (state, { favoriteId, isFavorite, isFavoritable }) => {
    state.paymentsList.find(obj => obj.operationId === favoriteId).favorite = isFavorite
    state.paymentsList.find(obj => obj.operationId === favoriteId).favoritable = isFavoritable
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
/** Clears Payments Services Feature states */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.paymentsList = []
    state.paymentsHasMore = []
    state.channelsList = []
    state.operationDetails = []
    state.paymentsStatusList = []
}
